import React, { memo } from 'react';
import PropTypes from 'prop-types';

const LoaderBar = ({ isVisible, className }) => {
  if (!isVisible) return null;

  return (
    <div
      className={`fixed top-0 left-0 w-full h-0.5 lg:h-1 rounded z-50 bg-gradient-to-r from-brand-primary to-brand-primary animate-slideRight bg-repeat-y bg-transparent ${className}`}
      style={{ backgroundSize: '20%', backgroundPosition: '-25% 0' }}
    />
  );
};

LoaderBar.propTypes = {
  isVisible: PropTypes.bool,
  className: PropTypes.string
};

LoaderBar.defaultProps = {
  className: ''
}

export default memo(LoaderBar);
